import { Box, TextField } from "@mui/material";
import React, { useEffect } from "react";

interface FormProps {
  data: Record<string, any>;
  updateData: (data: Record<string, any>) => void;
  validateForm: (isValid: boolean) => void;
}

export default function SecondForm({ data, updateData, validateForm }: FormProps) {
  const [companyname, setCompanyName] = React.useState(data.companyname || '');
  const [email, setEmail] = React.useState(data.email || '');
  const [telefono, setTelefono] = React.useState(data.telefono || '');
  const [emailError, setEmailError] = React.useState(false);
  const [telefonoError, setTelefonoError] = React.useState(false);

  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  const phoneRegex = /^[0-9]{10}$/;

  useEffect(() => {
    // Validar que los campos de correo electrónico y teléfono sean válidos y no estén vacíos
    const isEmailValid = email ? emailRegex.test(email) : false; 
    const isPhoneValid = telefono ? phoneRegex.test(telefono) : false;

    // Validar el formulario solo cuando email y telefono sean válidos
    validateForm(isEmailValid && isPhoneValid);

    // Actualizar datos, asegurando que "companyname" se envíe como cadena vacía si está vacío
    updateData({ ...data, companyname: companyname || '', email, telefono });
  }, [companyname, email, telefono, validateForm, updateData, data]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'companyname') {
      setCompanyName(value);
    } else if (name === 'email') {
      setEmail(value);
    } else if (name === 'telefono') {
      setTelefono(value);
    }
    updateData({ ...data, [name]: value });
  };

  const handleBlur = (field: string) => {
    if (field === 'email') {
      const isValid = emailRegex.test(email);
      setEmailError(!isValid);
      validateForm(isValid && phoneRegex.test(telefono));
    } else if (field === 'telefono') {
      const isValid = phoneRegex.test(telefono);
      setTelefonoError(!isValid);
      validateForm(isValid && emailRegex.test(email));
    }
  };

  return (
    <Box component="form" sx={{ mt: 2, width: { xs: '100%', md: '500px' }, maxWidth: 500 }}>
      <TextField
        label="Nombre de la compañía (opcional)"
        name="companyname"
        value={companyname}
        onChange={handleChange}
        sx={{
          mb: 2,
          '& .MuiInputBase-root': { height: 50 },
          width: '100%'
        }}
      />
      <TextField
        label="Email"
        name="email"
        value={email}
        onChange={handleChange}
        onBlur={() => handleBlur('email')}
        error={emailError}
        helperText={emailError ? 'Correo electrónico inválido' : ''}
        sx={{
          mb: 2,
          '& .MuiInputBase-root': { height: 50 },
          width: '100%'
        }}
      />
      <TextField
        label="Teléfono"
        name="telefono"
        value={telefono}
        onChange={handleChange}
        onBlur={() => handleBlur('telefono')}
        error={telefonoError}
        helperText={telefonoError ? 'Teléfono inválido' : ''}
        sx={{
          '& .MuiInputBase-root': { height: 50 },
          width: '100%'
        }}
      />
    </Box>
  );
}
